import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BloqLogo from "@/components/BloqLogo";
import MarketingScrollToTop from "@/components/MarketingScrollToTop";
import { useAuth } from "@/contexts/AuthContext";

const LINKS = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/beta-signup", label: "Join the Beta" },
  { to: "/fund-a-feature", label: "Fund a Feature" },
  { to: "/invest", label: "Invest" },
  { to: "/feedback", label: "Feedback" },
  { to: "/contact", label: "Contact" },
];

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header
      className="sticky top-0 z-40"
      style={{
        background: "rgba(251,252,252,0.84)",
        backdropFilter: "blur(20px)",
      }}
      data-testid="marketing-nav"
    >
      <MarketingScrollToTop />
      <div className="bloq-container flex items-center justify-between h-16">
        <BloqLogo size={26} />
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`marketing-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#005e7a]" : "text-[#4a4a52] hover:text-[#1a1a1f]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-4">
          {user ? (
            <button
              data-testid="nav-open-app-button"
              className="bloq-btn-primary"
              onClick={() => navigate("/app")}
            >
              Open Bloq
            </button>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login-link"
                className="text-sm font-medium text-[#4a4a52] hover:text-[#005e7a]"
              >
                Log in
              </Link>
              <Link to="/beta-disclaimer" data-testid="nav-signup-button" className="bloq-btn-primary">
                Start free
              </Link>
            </>
          )}
        </div>
        <button
          className="md:hidden w-10 h-10 rounded-lg flex items-center justify-center"
          onClick={() => setOpen((v) => !v)}
          data-testid="marketing-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden px-5 pb-5 pt-2 bg-white/95 backdrop-blur-xl">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="py-2.5 px-3 rounded-lg text-sm font-medium hover:bg-[#f5efe6]"
              >
                {l.label}
              </NavLink>
            ))}
            <div className="h-px bg-black/5 my-2" />
            {user ? (
              <Link to="/app" onClick={() => setOpen(false)} className="bloq-btn-primary text-center">
                Open Bloq
              </Link>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={() => setOpen(false)}
                  className="py-2.5 px-3 rounded-lg text-sm font-medium hover:bg-[#f5efe6]"
                >
                  Log in
                </Link>
                <Link to="/beta-disclaimer" onClick={() => setOpen(false)} className="bloq-btn-primary text-center">
                  Start free
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
